import AnnotationFormProvider from '../FormContext';
import Dialog from './Dialog';

export default function DialogWrapper() {
  return (
    <AnnotationFormProvider>
      <Dialog />
    </AnnotationFormProvider>
  );
}
